<template>
  <div class="animated fadeIn">
    <basic-heading title="Reference Documents"></basic-heading>
    <br />
    <b-table :items="items">
      <template #cell(links)="data">
        <b-button
          v-for="(i, k) in data.value"
          :key="k"
          :variant="i.variant"
          tag="a"
          target="_blank"
          :href="i.url"
          class="mr-2"
        >
          <i :class="i.icon" />
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";

export default {
  name: "ReferenceDocuments",
  components: {
    BasicHeading,
  },
  data() {
    return {
      items: [
        {
          title: "Homeowner Site Evaluation Declaration Form",
          links: [
            {
              url: "./docs/Homeowner Site Evaluation Declaration Form.pdf",
              icon: "fal fa-file-pdf",
              variant: "dark",
            },
            {
              url: "./docs/Homeowner Site Evaluation Declaration Form.docx",
              icon: "fal fa-file-word",
              variant: "primary",
            },
          ],
        },
        {
          title: "Soil Sampling Request",
          links: [
            {
              url: "./docs/Soil Sampling Request.pdf",
              icon: "fal fa-file-pdf",
              variant: "dark",
            },
            {
              url: "./docs/Soil Sampling Request.docx",
              icon: "fal fa-file-excel",
              variant: "success",
            },
          ],
        },
      ],
    };
  },
};
</script>
